import { defineMessages } from 'react-intl';

const messages = defineMessages({
  portfolioSummary: {
    id: 'App.AppBarNavDrawer.PropertySearchMenu.portfolioSummary',
    defaultMessage: 'Portfolio Summary',
  },
  includeInactive: {
    id: 'App.AppBarNavDrawer.PropertySearchMenu.includeInactive',
    defaultMessage: 'Include Inactive',
  },
  logOut: {
    id: 'App.AppBarNavDrawer.UserMenu.logOut',
    defaultMessage: 'Log Out',
  },
  switchUser: {
    id: 'App.AppBarNavDrawer.UserMenu.switchUser',
    defaultMessage: 'Switch User',
  },
  confirmLogOut: {
    id: 'App.AppBarNavDrawer.UserMenu.confirmLogOut',
    defaultMessage: 'Are you sure you want to log out?',
  },
  trainingProperties: {
    id: 'App.AppBarNavDrawer.PropertySearchMenu.trainingProperties',
    defaultMessage: 'Training Properties',
  },
  assignedProperties: {
    id: 'App.AppBarNavDrawer.PropertySearchMenu.assignedProperties',
    defaultMessage: 'Assigned Properties',
  },
  navCommunications: {
    id: 'App.AppBarNavDrawer.nav.Communications',
    defaultMessage: 'Connect',
  },
  navMessagingHub: {
    id: 'App.AppBarNavDrawer.nav.MessagingHub',
    defaultMessage: 'Conversations',
  },
  navMessageHub: {
    id: 'App.AppBarNavDrawer.nav.MessageHub',
    defaultMessage: 'Conversations',
  },
  navManageCommunications: {
    id: 'App.AppBarNavDrawer.nav.ManageCommunications',
    defaultMessage: 'Broadcasts',
  },
});

export default messages;
